import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";

export function preview_template(channel, context_id) {
    return uly.api.start().follow("uly:data")
        .follow("uly:documenttemplate", {
            "nodata": 1
        })
        .post("uly:preview", {
            "zones": ko.toJS(channel.zones),
            "channel": ko.unwrap(channel.channel.key_code),
            "layout_id": ko.unwrap(channel.layout_id),
            "title": ko.unwrap(channel.title),
            "context_id": context_id
        }).then(function (result) {
            uly.dialogs.execute(result.dialog_markup, {
                buttons: [{
                    "button": "cancel",
                    "caption": _("communications_caption_back", "Back"),
                    "button_class": "btn",
                    "icon": "fa fa-times-circle",
                    "action": "closedialog"
                }],
                "title": _("communications_preview_template_dialog_title", "Preview Document Template")
            }, result.data);
        }, function (error) {
            uly.utils.show_results({
                "success": false,
                "error": _("communications_preview_failed_to_generate_error", "Could not generate preview due to an error. The layout may not be valid.")
            });
        });

}


export function preview_templated_document(document, title, context_id) {
    return uly.api.start().follow("uly:data")
        .follow("uly:document", {
            "nodata": 1
        })
        .post("uly:preview", {
            "document": ko.toJS(document),
            "title": ko.toJS(title),
            "context_id": context_id
        }).then(function (result) {
            uly.dialogs.execute(result.dialog_markup, {
                title: _("communications_preview_dialog_title", "Document Preview"),
                buttons: [{
                    "button": "cancel",
                    "caption": _("communications_caption_back", "Back"),
                    "button_class": "btn",
                    "icon": "fa fa-times-circle",
                    "action": "closedialog"
                }]
            }, result.data);
        }, function (error) {
            uly.utils.show_results({
                "success": false,
                "error": _("communications_preview_failed_to_generate_error", "Could not generate preview due to an error. The layout may not be valid.")
            });
        });

}

